import './style.sass';
import trashIcon from 'assets/img/icons/trashIcon.svg';
import { ReactSVG } from 'react-svg';
import { CopyButton } from '../CopyBtn';
import { Spinner } from '../Spinner';

type Props = {
    url: string,
    onDelete?: () => void,
    onCopy?: () => void,
    isLoading?: boolean,
};

export const UrlItemWithControlls = ({ url, onCopy, onDelete, isLoading }: Props) => {
    const onClickCopy = () => {
        navigator.clipboard.writeText(url);

        if (onCopy) {
            onCopy();
        }
    };

    return (
        <div className="playlist-item">
            <span className="p1-medium">{url}</span>

            <div className="playlist-item__btns">
                <CopyButton onClick={onClickCopy}/>

                {!!onDelete && (isLoading
                    ? <div className="playlist-item__loader">
                        <Spinner/>
                    </div>
                    : <div className="delete-btn" onClick={onDelete}>
                        <ReactSVG src={trashIcon}/>
                    </div>)
                }
            </div>
        </div>
    );
};
